import { configureStore } from "@reduxjs/toolkit";
import messageReducer from "./slice/messageSlice";
import authReducer from "./slice/authSlice";
import userReducer from "./slice/userSlice";
import roleReducer from "./slice/roleSlice";
import cameraReducer from "./slice/cameraSlice";
import summaryReducer from "./slice/summarySlice";
import jumpReducer from "./slice/jumpSlice";
import leanReducer from "./slice/leanSlice";
import peopleReducer from "./slice/peopleSlice";
import analyticReducer from "./slice/analyticSlice";
import deviceReducer from "./slice/deviceSlice";
import unitsReducer from "./slice/unitsSlice";
import roleModuleReducer from "./slice/roleModuleSlice";
import sensorReducer from "./slice/sensorSlice";
import sitesReducer from "./slice/sitesSlice";
import modulReducer from "./slice/modulSlice";
import userDetailReducer from "./slice/userDetailSlice";
import liveDetectionReducer from "./slice/liveDetectionSlice";

export const Store = configureStore({
  reducer: {
    auth: authReducer,
    message: messageReducer,
    role: roleReducer,
    user: userReducer,
    camera: cameraReducer,
    summary: summaryReducer,
    people: peopleReducer,
    lean: leanReducer,
    jump: jumpReducer,
    analytic: analyticReducer,
    device: deviceReducer,
    units: unitsReducer,
    sensor: sensorReducer,
    sites: sitesReducer,
    roleModule: roleModuleReducer,
    modul: modulReducer,
    userDetail: userDetailReducer,
    liveDetection: liveDetectionReducer,
  },
});
